const _slideUpAndFadeIn = (start) => {
  return {
    visible: {
      opacity: 1,
      y: 0,
    },
    hidden: {
      opacity: 0,
      y: start || 30
    }
  }
}

export const fadeIn = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  }
}

export const page = {
  initial: 'start',
  animate: 'in',
  exit: 'out',
  variants: {
    start: {
      opacity: 0,
      y: 30
    },
    in: {
      opacity: 1,
      y: 0
    },
    out: {
      opacity: 0,
      y: 30,
      transition: {
        type: "tween",
        ease: "anticipate",
        duration: 0.4
      }
    }
  }
}

export const rowsContainer = {
  initial: 'hidden',
  animate: 'visible',
  variants: {
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.1,
        staggerChildren: 0.15,
      },
    },
    hidden: {
      opacity: 0
    }
  }
}

export const hud = {
  initial: 'start',
  animate: 'in',
  exit: 'out',
  variants: {
    start: {
      x: '100%'
    },
    in: {
      x: 0
    },
    out: {
      x: 100,
      opacity: 0,
      transition: {
        type: "tween",
        ease: "anticipate",
        duration: 0.4
      }
    }
  }
}

export const row = {
  variants: _slideUpAndFadeIn()
}

export const footer = {
  initial: 'hidden',
  animate: 'visible',
  variants: _slideUpAndFadeIn()
}

export const cardRight = {
  initial: 'hidden',
  animate: 'visible',
  variants: {
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.3
      }
    },
    hidden: {
      opacity: 0,
      x: 60
    }
  }
}